<template>
  <el-dialog :title="mode === 'create' ? '创建培训任务' : '编辑培训任务'" :visible.sync="dialogVisible" width="760px"
    @close="handleClose" append-to-body>
    <el-form ref="form" :model="form" :rules="rules" label-width="110px" size="small">
      <el-form-item label="培训标题" prop="title">
        <el-input v-model="form.title" placeholder="请输入培训标题" />
      </el-form-item>

      <el-form-item label="培训分类" prop="category">
        <el-cascader v-model="form.category" :options="trainingCategoryTree" :props="categoryCascaderProps"
          placeholder="请选择分类" filterable style="width: 100%" @change="handleCategoryChange" />
      </el-form-item>

      <el-row :gutter="16">
        <el-col :span="12">
          <el-form-item label="培训资料" prop="materialsId">
            <el-button type="primary" size="small" @click="handleSelectMaterials">
              {{ selectedMaterials ? "更换资料" : "选择培训资料" }}
            </el-button>
            <div v-if="selectedMaterials" class="picked-card">
              <div class="picked-head">
                <span class="picked-title">{{ selectedMaterials.title }}</span>
                <el-tag size="mini">{{ trainingCategoryText(selectedMaterials.category) || "未分类" }}</el-tag>
                <el-button size="mini" type="text" @click="handleClearMaterials">清除</el-button>
              </div>
              <div v-if="selectedMaterials.description" class="picked-desc">{{ selectedMaterials.description }}</div>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="考试题目" prop="examId">
            <el-button type="primary" size="small" @click="handleSelectExam">
              {{ selectedExam ? "更换考试" : "选择考试题目" }}
            </el-button>
            <div v-if="selectedExam" class="picked-card">
              <div class="picked-head">
                <span class="picked-title">{{ selectedExam.title }}</span>
                <el-tag v-if="selectedExam.category" size="mini">{{ trainingCategoryText(selectedExam.category) }}</el-tag>
                <el-tag size="mini">{{ selectedExam.questions ? selectedExam.questions.length : 0 }}题</el-tag>
                <el-button size="mini" type="text" @click="handleClearExam">清除</el-button>
              </div>
              <div class="picked-desc">总分 {{ selectedExam.totalScore }} 分，及格 {{ selectedExam.passScore }} 分</div>
            </div>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="16">
        <el-col :span="12">
          <el-form-item label="人脸校验" prop="faceVerifyEnabled">
            <el-switch v-model="form.faceVerifyEnabled" active-text="开启" inactive-text="关闭" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="优先级" prop="priority">
            <el-input-number v-model="form.priority" :min="1" :max="10" controls-position="right" style="width: 120px" />
            <span class="field-hint">越大越优先</span>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row v-if="form.faceVerifyEnabled" :gutter="16">
        <el-col :span="12">
          <el-form-item label="校验次数" prop="faceVerifyCount">
            <el-input-number v-model="form.faceVerifyCount" :min="1" :max="5" controls-position="right"
              style="width: 120px" />
            <span class="field-hint">视频中后段抓拍</span>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="16">
        <el-col :span="12">
          <el-form-item label="完成截止" prop="latestFinishTime">
            <el-date-picker v-model="form.latestFinishTime" type="date" placeholder="不填则不限制" format="yyyy-MM-dd"
              value-format="yyyy-MM-dd 23:59:59" clearable style="width: 100%" />
            <div class="field-hint">不填则司机端不展示</div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="过期天数" prop="expireDays">
            <el-input-number v-model="form.expireDays" :min="0" :max="3650" :precision="0" controls-position="right"
              placeholder="天" style="width: 120px" />
            <el-button v-if="form.expireDays != null" type="text" size="small" @click="form.expireDays = undefined">
              清空
            </el-button>
            <div class="field-hint">默认带资料天数。0 表示完成后立即隐藏</div>
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item label="注意事项" prop="notice">
        <el-input v-model="form.notice" type="textarea" :rows="2" placeholder="给司机看。不填则司机端不展示" />
      </el-form-item>

      <el-form-item label="备注" prop="remark">
        <el-input v-model="form.remark" type="textarea" :rows="2" placeholder="给运营人员看，司机端不展示" />
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="handleClose">取消</el-button>
      <el-button size="small" type="primary" @click="handleConfirm" :loading="confirmLoading">确定</el-button>
    </div>

    <!-- 选择资料对话框 -->
    <MaterialsSelectorDialog :visible.sync="materialsSelectorVisible" :category="form.category"
      @confirm="handleMaterialsSelected" />

    <!-- 选择考试对话框 -->
    <ExamSelectorDialog :visible.sync="examSelectorVisible" :category="form.category" @confirm="handleExamSelected" />
  </el-dialog>
</template>

<script>
import MaterialsSelectorDialog from "./MaterialsSelectorDialog.vue";
import ExamSelectorDialog from "./ExamSelectorDialog.vue";
import { saveTraining } from "@/api/new_training";
import trainingCategoryMixin from "../utils/trainingCategory";
export default {
  name: "TrainingDialog",
  mixins: [trainingCategoryMixin],
  components: {
    MaterialsSelectorDialog,
    ExamSelectorDialog
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    formData: {
      type: Object,
      default: () => ({})
    },
    mode: {
      type: String,
      default: "create" // create | edit
    }
  },
  data() {
    return {
      dialogVisible: false,
      confirmLoading: false,
      form: {
        title: "",
        category: "",
        materialsId: "",
        examId: "",
        priority: 1,
        notice: "",
        remark: "",
        latestFinishTime: null,
        expireDays: undefined,
        faceVerifyEnabled: false,
        faceVerifyCount: 2
      },
      rules: {
        title: [{ required: true, message: "请输入培训标题", trigger: "blur" }],
        category: [{ required: true, message: "请选择培训分类", trigger: "change" }],
        examId: [{ required: true, message: "请选择考试题目", trigger: "change" }],
        faceVerifyCount: [
          {
            validator: (rule, value, callback) => {
              if (!this.form.faceVerifyEnabled) {
                callback();
                return;
              }
              if (!value || value < 1) {
                callback(new Error("请填写人脸校验次数"));
                return;
              }
              callback();
            },
            trigger: "change"
          }
        ]
      },

      // 选择器对话框
      materialsSelectorVisible: false,
      examSelectorVisible: false,

      selectedExam: null,
      selectedMaterials: null
    };
  },
  watch: {
    visible: {
      handler(val) {
        this.dialogVisible = val;
        if (val) {
          this.initForm();
        }
      },
      immediate: true
    }
  },
  methods: {
    // 初始化表单
    initForm() {
      if (this.mode === "create") {
        this.form = {
          title: "",
          category: "",
          materialsId: "",
          examId: "",
          priority: 1,
          notice: "",
          remark: "",
          latestFinishTime: null,
          expireDays: undefined,
          faceVerifyEnabled: false,
          faceVerifyCount: 2
        };
        this.selectedMaterials = null;
        this.selectedExam = null;
      } else {
        const data = { ...this.formData };
        if (!data.notice && data.remark) {
          data.notice = data.remark;
          data.remark = "";
        }
        data.notice = data.notice || "";
        data.remark = data.remark || "";
        if (data.faceVerifyEnabled == null) {
          data.faceVerifyEnabled = false;
        }
        if (!data.faceVerifyCount) {
          data.faceVerifyCount = 2;
        }
        if (data.latestFinishTime) {
          data.latestFinishTime = String(data.latestFinishTime).slice(0, 10) + " 23:59:59";
        } else {
          data.latestFinishTime = null;
        }
        data.expireDays = this.normalizeExpireDays(data.expireDays);
        this.form = data;
        this.form.category = this.normalizeLeafCategory(this.form.category);
        this.selectedMaterials = this.formData.trainMaterials;
        this.selectedExam = this.formData.trainExam;
      }
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate();
      });
    },

    handleCategoryChange() {
      if (this.selectedMaterials && this.selectedMaterials.category !== this.form.category) {
        this.handleClearMaterials();
      }
      if (this.selectedExam && this.selectedExam.category !== this.form.category) {
        this.handleClearExam();
      }
    },

    // 选择培训资料
    handleSelectMaterials() {
      this.materialsSelectorVisible = true;
    },

    // 选择考试题目
    handleSelectExam() {
      this.examSelectorVisible = true;
    },

    // 资料选择确认
    handleMaterialsSelected(materials) {
      this.form.materialsId = materials.id;
      this.selectedMaterials = materials;
      this.form.expireDays = this.normalizeExpireDays(materials && materials.expireDays);
    },

    normalizeExpireDays(value) {
      if (value === null || value === undefined || value === "") return undefined;
      const days = Number(value);
      if (!Number.isInteger(days) || days < 0) return undefined;
      return days;
    },

    // 考试选择确认
    handleExamSelected(exam) {
      this.form.examId = exam.id;
      this.selectedExam = exam;
    },

    // 清除资料
    handleClearMaterials() {
      this.form.materialsId = "";
      this.selectedMaterials = null;
    },

    // 清除考试
    handleClearExam() {
      this.form.examId = "";
      this.selectedExam = null;
    },

    // 确认
    handleConfirm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.confirmLoading = true;
          try {
            const data = { ...this.form };
            data.expireDays = this.normalizeExpireDays(data.expireDays) ?? null;
            await saveTraining(data);
            this.$emit("confirm", data);
            this.handleClose();
          } catch (error) {
            this.$message.error("保存失败");
            console.error(error);
          } finally {
            this.confirmLoading = false;
          }
        }
      });
    },

    // 关闭
    handleClose() {
      this.dialogVisible = false;
      this.$emit("update:visible", false);
    }
  }
};
</script>

<style lang="less" scoped>
.picked-card {
  margin-top: 8px;
  padding: 8px 10px;
  background: #f8f9fa;
  border-radius: 4px;
  border: 1px solid #e4e7ed;
  overflow: hidden;

  .picked-head {
    display: flex;
    align-items: center;
    min-width: 0;
  }

  .picked-title {
    flex: 1;
    min-width: 0;
    font-weight: 600;
    color: #303133;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .el-tag,
  .el-button {
    flex-shrink: 0;
    margin-left: 6px;
  }

  .picked-desc {
    margin-top: 4px;
    color: #606266;
    font-size: 12px;
    line-height: 1.4;
    word-break: break-all;
  }
}

.field-hint {
  color: #909399;
  font-size: 12px;
  line-height: 1.4;
}

span.field-hint {
  margin-left: 8px;
}

div.field-hint {
  margin-top: 2px;
}

.dialog-footer {
  text-align: right;
}
</style>
